module.exports = __webpack_public_path__ + "media/scanFailure.92d195fa.wav";